import React, { Component } from "react";
import { useEffect, useMemo, useState, useRef, useContext } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import CollegueProfile from "./CollegueProfile";
import "./style.css";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import PuffLoader from "react-spinners/PuffLoader";
import { Context } from "../../themeContext";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { CollectionsOutlined } from "@material-ui/icons";
import { propTypes } from "react-bootstrap/esm/Image";
import { renderStatus } from "../../utils";
//const ENDPOINT = "https://192.168.30.40:5004";
const token = localStorage.getItem("AccessToken");
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const BackendURL = window.BackendURLCmk;
var lien = window.location.href;
//console.log(lien);
const var22 = lien.split("/");

function appelVideo(number) {
  document.getElementById("numDisplay").value = number;
  document.getElementById("MakeCallVideo").click();
}

function Colleguebox({ collegue, avance }) {
  const { t } = useTranslation("common");

  const [state, dispatch] = useContext(Context);
  const [style, setStyle] = useState({ display: "none" });

  const [show, setShow] = useState(false);

  const hideModal = () => setShow(false);
  const showModal = () => setShow(true);

  const [showetat_mobile, setshowetat_mobile] = useState("");
  const [showetat_deskphone, setshowetat_deskphone] = useState("");
  const [showetat_principal, setshowetat_principal] = useState("");
  const [showetat, setshowetat] = useState("");
  const etatPhone1 = () => {
    if (
      collegue.collection.deskphone.etat == "Connecté" ||
      collegue.collection.mobilephone.etat == "Connecté" ||
      collegue.collection.principal.etat == "Connecté"
    ) {
      if (
        collegue.collection.deskphone.encom == "" &&
        collegue.collection.mobilephone.encom == "" &&
        collegue.collection.principal.encom == ""
      ) {
        return (
          <span>
            {" "}
            <span
              class="absolute top-0 left-0 block h-2.5 w-2.5 rounded-full  opacity-75"
              style={{ backgroundColor: "#62bd19" }}
            ></span>
            <span
              className=" absolute top-0 left-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white"
              style={{ backgroundColor: "#62bd19" }}
            ></span>
          </span>
        );
      } else if (
        collegue.collection.deskphone.encom !== "" ||
        collegue.collection.mobilephone.encom !== "" ||
        collegue.collection.principal.encom !== ""
      ) {
        if (
          collegue.collection.deskphone.encom == "Sonnerie" ||
          collegue.collection.mobilephone.encom == "Sonnerie" ||
          collegue.collection.principal.encom == "Sonnerie"
        ) {
          return (
            <span>
              <span class="animate-ping absolute top-0 left-0 inline-flex h-3 w-3 rounded-full bg-yellow-500 opacity-95"></span>
              <span class="absolute top-0 left-0 block h-2.5 w-2.5 rounded-full h-2.5 w-2.5 bg-yellow-500"></span>
            </span>
          );
        } else {
          return (
            // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
            <span>
              <span class="animate-ping absolute top-0 left-0 inline-flex h-3 w-3 rounded-full bg-red-500 opacity-95"></span>
              <span class="absolute top-0 left-0 block h-2.5 w-2.5 rounded-full h-2.5 w-2.5 bg-red-500"></span>
            </span>
          );
        }
      }
    } else {
      if (
        collegue.collection.deskphone.encom == "" &&
        collegue.collection.mobilephone.encom == "" &&
        collegue.collection.principal.encom == ""
      ) {
        return (
          <span className="bg-gray-300 dark:bg-gray-400 absolute top-0 left-0 block h-3 w-3 rounded-full ring-2 ring-gray-200"></span>
        );
      } else {
        <span className="bg-red-500 absolute top-0 left0 block h-3 w-3 rounded-full ring-2 ring-white"></span>;
      }
    }
  };

  const etatPhone4 = () => {
    if (showetat == "use") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute top-0 left-0 inline-flex h-3 w-3 rounded-full bg-red-500 opacity-95"></span>
          <span class="absolute top-0 left-0 block h-2.5 w-2.5 rounded-full h-2.5 w-2.5 bg-red-500"></span>
        </span>
      );
    }
    if (showetat == "idle") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          {" "}
          <span
            class="absolute top-0 left-0 block h-2.5 w-2.5 rounded-full  opacity-75"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
          <span
            className=" absolute top-0 left-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
        </span>
      );
    }
    if (showetat == "Ringing") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute top-0 left-0 inline-flex h-3 w-3 rounded-full bg-yellow-500 opacity-95"></span>
          <span class="absolute top-0 left-0 block h-2.5 w-2.5 rounded-full h-2.5 w-2.5 bg-yellow-500"></span>
        </span>
      );
    }
  };
  const etatPhonedevice = (etat, com) => {
    if (etat == "Connecté") {
      if (com == "") {
        return (
          <span>
            {" "}
            <span
              class="absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full  opacity-75"
              style={{ backgroundColor: "#62bd19" }}
            ></span>
            <span
              className=" absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full ring-2 ring-white"
              style={{ backgroundColor: "#62bd19" }}
            ></span>
          </span>
        );
      } else if (com !== "") {
        if (com == "Sonnerie") {
          return (
            <span>
              <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-yellow-500 opacity-95"></span>
              <span class="absolute bottom-0 right-0 block  rounded-full h-1.5 w-1.5 bg-yellow-500"></span>
            </span>
          );
        } else {
          return (
            <span>
              <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-red-500 opacity-95"></span>
              <span class="absolute bottom-0 right-0 block rounded-full h-1.5 w-1.5 bg-red-500"></span>
            </span>
          );
        }
      }
    } else {
      if (com == "") {
        return (
          <span className="bg-gray-300 dark:bg-gray-400 absolute bottom-0 right-0 block h-2 w-2 rounded-full ring-2 ring-gray-200"></span>
        );
      } else {
        <span className="bg-red-500 absolute bottom-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white"></span>;
      }
    }
  };
  const mobile = () => {
    if (showetat_mobile == "use") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-red-500 opacity-95"></span>
          <span class="absolute bottom-0 right-0 block  rounded-full h-1.5 w-1.5 bg-red-500"></span>
        </span>
      );
    }
    if (showetat_mobile == "idle") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          {" "}
          <span
            class="absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full  opacity-75"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
          <span
            className=" absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full ring-2 ring-white"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
        </span>
      );
    }
    if (showetat_mobile == "Ringing") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-yellow-500 opacity-95"></span>
          <span class="absolute bottom-0 right-0 block  rounded-full h-1.5 w-1.5 bg-yellow-500"></span>
        </span>
      );
    }
  };

  const Principal = () => {
    if (showetat_principal == "use") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-red-500 opacity-95"></span>
          <span class="absolute bottom-0 right-0 block  rounded-full h-1.5 w-1.5 bg-red-500"></span>
        </span>
      );
    }
    if (showetat_principal == "idle") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          {" "}
          <span
            class="absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full  opacity-75"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
          <span
            className=" absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full ring-2 ring-white"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
        </span>
      );
    }
    if (showetat_principal == "Ringing") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-yellow-500 opacity-95"></span>
          <span class="absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full  bg-yellow-500"></span>
        </span>
      );
    }
  };
  const deskphone = () => {
    if (showetat_deskphone == "use") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-red-500 opacity-95"></span>
          <span class="absolute bottom-0 right-0 block  rounded-full h-1.5 w-1.5 bg-red-500"></span>
        </span>
      );
    }
    if (showetat_deskphone == "idle") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          {" "}
          <span
            class="absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full  opacity-75"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
          <span
            className=" absolute bottom-0 right-0 block h-1.5 w-1.5 rounded-full ring-2 ring-white"
            style={{ backgroundColor: "#62bd19" }}
          ></span>
        </span>
      );
    }
    if (showetat_deskphone == "Ringing") {
      return (
        // <span className="animate-ping bg-red-500 absolute top-0 right-0 block h-1.5 w-1.5 rounded-full opacity-75 "></span>
        <span>
          <span class="animate-ping absolute bottom-0 right-0 inline-flex h-2 w-2 rounded-full bg-yellow-500 opacity-95"></span>
          <span class="absolute bottom-0 right-0 block rounded-full h-1.5 w-1.5 bg-yellow-500"></span>
        </span>
      );
    }
  };
  function winClose(url) {
    var win = window.open("", getWinName(url));
    win.close();
  }
  function getWinName(url) {
    return "win" + url.replace(/[^A-Za-z0-9\-\_]*/g, "");
  }
  function sendmessage(canal) {
    // return ()
    // window.close(
    //   `https://gounified.comunikcrm.info/comunik/messages/@${canal}`
    // );
    // var v1 = window.open(
    //   `https://gounified.comunikcrm.info/comunik/messages/@${canal}`,
    //   "MsgWindow"
    // );
  }

  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  // Store current value in ref

  function setglobalcollegue_mobile(etat) {
    const tabcol = localStorage.getItem("tabcollegue");
    const tabcol2 = JSON.parse(tabcol);
    var itab = tabcol2;
    if (itab != null) {
      var index = itab.findIndex((x) => x.poste == collegue.poste);
      itab[index].collection.mobilephone.encom = etat;
      console.log(collegue.poste);
      localStorage.setItem("tabcollegue", JSON.stringify(itab));
    } else {
      console.log("waitcollg");
    }

    //dispatch({ type: "SET_POSTS", payload: itab });
  }
  function setglobalcollegue_deskphone(etat) {
    const tabcol = localStorage.getItem("tabcollegue");
    const tabcol2 = JSON.parse(tabcol);
    var itab = tabcol2;
    if (itab != null) {
      var index = itab.findIndex((x) => x.poste == collegue.poste);
      itab[index].collection.deskphone.encom = etat;
      console.log(collegue.poste);
      localStorage.setItem("tabcollegue", JSON.stringify(itab));
    } else {
      console.log("waitcollg");
    }

    //dispatch({ type: "SET_POSTS", payload: itab });
  }
  function setglobalcollegue_principal(etat) {
    const tabcol = localStorage.getItem("tabcollegue");
    const tabcol2 = JSON.parse(tabcol);
    if (tabcol2 != null) {
      const index = tabcol2.findIndex((x) => x.poste == collegue.poste);
      if (tabcol2[index]) tabcol2[index].collection.principal.encom = etat;
      localStorage.setItem("tabcollegue", JSON.stringify(tabcol2));
    } else {
      console.log("waitcollg");
    }

    //dispatch({ type: "SET_POSTS", payload: itab });
  }
  useEffect(() => {
    state?.socket?.on("FromAPI", (data) => {
      if (data.compte !== compte) return;
      if (data.poste == collegue.collection.principal.poste) {
        if (
          data.EtatCommunication == "InUse" ||
          data.EtatCommunication == "Busy"
        ) {
          setshowetat_principal("use");
          setshowetat("use");
          var yo = "En com";

          setglobalcollegue_principal(yo);
        }
        if (data.EtatCommunication == "Idle") {
          setshowetat_principal("idle");
          var yo = "";
          setglobalcollegue_principal(yo);

          if (showetat_deskphone == "use" || showetat_mobile == "use") {
            setshowetat("use");
          } else if (
            showetat_deskphone == "Ringing" ||
            showetat_mobile == "Ringing"
          ) {
            setshowetat("Ringing");
          } else {
            setshowetat("idle");
          }
        }
        if (data.EtatCommunication == "Ringing") {
          var ring = "Ringing";
          setshowetat_principal(ring);
          var yo = "Sonnerie";
          setglobalcollegue_principal(yo);

          if (showetat_deskphone == "use" || showetat_mobile == "use") {
            setshowetat("use");
          } else if (
            showetat_deskphone == "Ringing" ||
            showetat_mobile == "Ringing"
          ) {
            setshowetat("Ringing");
          } else {
            setshowetat("Ringing");
          }
        }
      }

      if (data.poste == collegue.collection.mobilephone.poste) {
        if (
          data.EtatCommunication == "InUse" ||
          data.EtatCommunication == "Busy"
        ) {
          setshowetat_mobile("use");
          setshowetat("use");
          var yo = "En com";
          setglobalcollegue_mobile(yo);
        }
        if (data.EtatCommunication == "Idle") {
          setshowetat_mobile("idle");
          var yo = "";
          setglobalcollegue_mobile(yo);

          if (showetat_deskphone == "use" || showetat_principal == "use") {
            setshowetat("use");
          } else if (
            showetat_deskphone == "Ringing" ||
            showetat_principal == "Ringing"
          ) {
            setshowetat("Ringing");
          } else {
            setshowetat("idle");
          }
        }

        if (data.EtatCommunication == "Ringing") {
          var ring = "Ringing";
          setshowetat_mobile(ring);
          var yo = "Sonnerie";
          setglobalcollegue_mobile(yo);

          if (showetat_deskphone == "use" || showetat_principal == "use") {
            setshowetat("use");
          } else if (
            showetat_deskphone == "Ringing" ||
            showetat_principal == "Ringing"
          ) {
            setshowetat("Ringing");
          } else {
            setshowetat("Ringing");
          }
        }
      }
      if (data.poste == collegue.collection.deskphone.poste) {
        if (
          data.EtatCommunication == "InUse" ||
          data.EtatCommunication == "Busy"
        ) {
          setshowetat_deskphone("use");

          setshowetat("use");
          var yo = "En com";
          setglobalcollegue_deskphone(yo);
        }
        if (data.EtatCommunication == "Idle") {
          setshowetat_deskphone("idle");
          var yo = "";
          setglobalcollegue_deskphone(yo);

          if (showetat_mobile == "use" || showetat_principal == "use") {
            setshowetat("use");
          } else if (
            showetat_mobile == "Ringing" ||
            showetat_principal == "Ringing"
          ) {
            setshowetat("Ringing");
          } else {
            setshowetat("idle");
          }
        }
        if (data.EtatCommunication == "Ringing") {
          var ring = "Ringing";
          setshowetat_deskphone(ring);
          var yo = "Sonnerie";
          setglobalcollegue_deskphone(yo);

          if (showetat_mobile == "use" || showetat_principal == "use") {
            setshowetat("use");
          } else if (
            showetat_mobile == "Ringing" ||
            showetat_principal == "Ringing"
          ) {
            setshowetat("Ringing");
          } else {
            setshowetat("Ringing");
          }
        }
      }
    });
    return () => {
      state?.socket?.off("FromAPI");
    };
  }, [state?.socket]);

  return (
    <div
      className="max-w-7xl  px-2"
      onMouseEnter={(e) => {
        setStyle({ display: "block" });
      }}
      onMouseLeave={(e) => {
        setStyle({ display: "none" });
      }}
    >
      <div className="holaa relative rounded-lg border border-gray-300 bg-white px-2 py-2 shadow-sm  space-x-3 hover:border-gray-400 dark:bg-gray-900 dark:text-white transition-al ">
        <div className="group flex justify-between items-center">
          <div className="flex-1 flex items-center min-w-0 ">
            <span className="flex-shrink-0 inline-block relative">
              {collegue.photo_poste_interne ? (
                <img
                  class="h-14 w-14 rounded-full"
                  alt="collegue"
                  src={`${collegue.lien_photo_poste_interne}`}
                />
              ) : (
                <span className="inline-block h-14 w-14 rounded-full overflow-hidden bg-gray-100 dark:bg-gray-700">
                  <svg
                    className="h-full w-full text-gray-300 dark:text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                  </svg>
                </span>
              )}
              {showetat ? etatPhone4(showetat) : etatPhone1()}
              <div className=" absolute bottom-1 right-1">
                {renderStatus(collegue?.status_utilisateur ?? "5", t)}
              </div>
            </span>
            <div data-tip={collegue.nom} className="ml-4 truncate">
              <ReactTooltip />
              <p
                className="text-bg font-medium text-gray-900 truncate  dark:text-white transition-al "
                // style={{
                //   maxWidth: "150px",
                //   overflow: "hidden",
                //   whiteSpace: "nowrap",
                //   textOverflow: "ellipsis",
                // }}
              >
                {collegue.nom}
                {/* {props.collegue.nom} */}
              </p>
              <p className="text-lg text-gray-500 truncate flex">
                {collegue.poste}
              </p>
              {avance ? (
                <div
                  className="text-sm text-gray-500 truncate flex  mt-1 pb-2 pt-2 relative inline-block text-left"
                  // style={style}
                >
                  <span className="flex-shrink-0 inline-block relative mr-2 ">
                    <div className="dark:bg-gray-600 inline-flex items-center p-2.5 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-600 dark:text-gray-200"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    {showetat_principal
                      ? Principal(showetat_principal)
                      : etatPhonedevice(
                          collegue.collection.principal.etat,
                          collegue.collection.principal.encom
                        )}
                  </span>
                  <span className="flex-shrink-0 inline-block relative mr-2 ">
                    <div className="dark:bg-gray-600 inline-flex items-center p-2.5 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-gray-600 dark:text-gray-200"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    {showetat_mobile
                      ? mobile(showetat_mobile)
                      : etatPhonedevice(
                          collegue.collection.mobilephone.etat,
                          collegue.collection.mobilephone.encom
                        )}
                  </span>

                  <span className="flex-shrink-0 inline-block relative mr-2 ">
                    <div className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                      {" "}
                      {/* <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 17.026 17.026"
                      style={{ enableBackground: "new 0 0 17.026 17.026" }}
                      className="h-5 w-5 text-gray-600 dark:text-gray-200"
                      fill="currentColor"
                    > */}
                      <svg
                        className="h-5 w-5 text-gray-500 dark:text-gray-300"
                        fill="currentColor"
                        version="1.1"
                        viewBox="0 0 700 700"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <defs>
                          <symbol id="o" overflow="visible">
                            <path d="m29.312-1.75c-1.5117 0.78125-3.0898 1.3711-4.7344 1.7656-1.6367 0.40625-3.3398 0.60938-5.1094 0.60938-5.3125 0-9.5273-1.4844-12.641-4.4531-3.1055-2.9688-4.6562-7-4.6562-12.094s1.5508-9.125 4.6562-12.094c3.1133-2.9688 7.3281-4.4531 12.641-4.4531 1.7695 0 3.4727 0.19922 5.1094 0.59375 1.6445 0.39844 3.2227 0.99219 4.7344 1.7812v6.5938c-1.5312-1.0391-3.0391-1.8008-4.5156-2.2812-1.4805-0.48828-3.0391-0.73438-4.6719-0.73438-2.9375 0-5.2461 0.94531-6.9219 2.8281-1.6797 1.875-2.5156 4.4648-2.5156 7.7656 0 3.293 0.83594 5.8828 2.5156 7.7656 1.6758 1.875 3.9844 2.8125 6.9219 2.8125 1.6328 0 3.1914-0.23828 4.6719-0.71875 1.4766-0.48828 2.9844-1.2539 4.5156-2.2969z" />
                          </symbol>
                          <symbol id="c" overflow="visible">
                            <path d="m21.453-17.406c-0.67969-0.3125-1.3516-0.53906-2.0156-0.6875-0.65625-0.15625-1.3203-0.23438-1.9844-0.23438-1.9688 0-3.4844 0.63281-4.5469 1.8906-1.0547 1.2617-1.5781 3.0703-1.5781 5.4219v11.016h-7.6562v-23.922h7.6562v3.9219c0.97656-1.5625 2.1016-2.7031 3.375-3.4219 1.2812-0.71875 2.8125-1.0781 4.5938-1.0781 0.25 0 0.52344 0.011719 0.82812 0.03125 0.30078 0.023438 0.73438 0.070312 1.2969 0.14062z" />
                          </symbol>
                          <symbol id="b" overflow="visible">
                            <path d="m27.562-12.031v2.1875h-17.891c0.1875 1.793 0.83203 3.1367 1.9375 4.0312 1.1133 0.89844 2.6719 1.3438 4.6719 1.3438 1.6016 0 3.25-0.23438 4.9375-0.70312 1.6875-0.47656 3.4219-1.2031 5.2031-2.1719v5.8906c-1.8047 0.6875-3.6094 1.2031-5.4219 1.5469-1.8125 0.35156-3.6211 0.53125-5.4219 0.53125-4.3359 0-7.7031-1.0977-10.109-3.2969-2.3984-2.207-3.5938-5.2969-3.5938-9.2656 0-3.9062 1.1758-6.9727 3.5312-9.2031 2.3633-2.2383 5.6094-3.3594 9.7344-3.3594 3.7578 0 6.7695 1.1367 9.0312 3.4062 2.2578 2.2617 3.3906 5.2812 3.3906 9.0625zm-7.8594-2.5312c0-1.457-0.42969-2.6289-1.2812-3.5156-0.84375-0.89453-1.9492-1.3438-3.3125-1.3438-1.4922 0-2.6992 0.41797-3.625 1.25-0.91797 0.83594-1.4922 2.0391-1.7188 3.6094z" />
                          </symbol>
                          <symbol id="a" overflow="visible">
                            <path d="m14.391-10.766c-1.5938 0-2.793 0.27344-3.5938 0.8125-0.80469 0.54297-1.2031 1.3398-1.2031 2.3906 0 0.96875 0.32031 1.7305 0.96875 2.2812 0.64453 0.54297 1.5469 0.8125 2.7031 0.8125 1.4375 0 2.6445-0.51562 3.625-1.5469 0.98828-1.0312 1.4844-2.3203 1.4844-3.875v-0.875zm11.688-2.8906v13.656h-7.7031v-3.5469c-1.0312 1.4492-2.1875 2.5078-3.4688 3.1719s-2.8398 1-4.6719 1c-2.4805 0-4.4961-0.72266-6.0469-2.1719-1.543-1.4453-2.3125-3.3203-2.3125-5.625 0-2.8125 0.96094-4.8672 2.8906-6.1719 1.9375-1.3125 4.9688-1.9688 9.0938-1.9688h4.5156v-0.60938c0-1.207-0.48047-2.0938-1.4375-2.6562-0.94922-0.5625-2.4375-0.84375-4.4688-0.84375-1.6367 0-3.1562 0.16797-4.5625 0.5-1.4062 0.32422-2.7188 0.8125-3.9375 1.4688v-5.8281c1.6445-0.40625 3.2891-0.70703 4.9375-0.90625 1.6562-0.20703 3.3047-0.3125 4.9531-0.3125 4.3203 0 7.4375 0.85547 9.3438 2.5625 1.9141 1.6992 2.875 4.4609 2.875 8.2812z" />
                          </symbol>
                          <symbol id="h" overflow="visible">
                            <path d="m12.031-30.719v6.7969h7.875v5.4688h-7.875v10.141c0 1.1172 0.21875 1.8711 0.65625 2.2656 0.4375 0.38672 1.3125 0.57812 2.625 0.57812h3.9375v5.4688h-6.5625c-3.0234 0-5.1641-0.62891-6.4219-1.8906-1.2617-1.2578-1.8906-3.3984-1.8906-6.4219v-10.141h-3.7969v-5.4688h3.7969v-6.7969z" />
                          </symbol>
                          <symbol id="g" overflow="visible">
                            <path d="m19.953-20.422v-12.812h7.6875v33.234h-7.6875v-3.4531c-1.0547 1.4062-2.2148 2.4375-3.4844 3.0938-1.2734 0.65625-2.7422 0.98438-4.4062 0.98438-2.9492 0-5.3711-1.1719-7.2656-3.5156-1.8867-2.3438-2.8281-5.3594-2.8281-9.0469s0.94141-6.7031 2.8281-9.0469c1.8945-2.3438 4.3164-3.5156 7.2656-3.5156 1.6562 0 3.1172 0.33594 4.3906 1 1.2812 0.65625 2.4453 1.6836 3.5 3.0781zm-5.0469 15.484c1.6445 0 2.8945-0.59766 3.75-1.7969 0.86328-1.1953 1.2969-2.9297 1.2969-5.2031 0-2.2812-0.43359-4.0195-1.2969-5.2188-0.85547-1.1953-2.1055-1.7969-3.75-1.7969-1.625 0-2.8711 0.60156-3.7344 1.7969-0.85547 1.1992-1.2812 2.9375-1.2812 5.2188 0 2.2734 0.42578 4.0078 1.2812 5.2031 0.86328 1.1992 2.1094 1.7969 3.7344 1.7969z" />
                          </symbol>
                          <symbol id="f" overflow="visible">
                            <path d="m16.406-4.9375c1.6328 0 2.8828-0.59766 3.75-1.7969 0.86328-1.1953 1.2969-2.9297 1.2969-5.2031 0-2.2812-0.43359-4.0195-1.2969-5.2188-0.86719-1.1953-2.1172-1.7969-3.75-1.7969-1.6367 0-2.8906 0.60547-3.7656 1.8125-0.875 1.1992-1.3125 2.9336-1.3125 5.2031 0 2.2617 0.4375 3.9961 1.3125 5.2031 0.875 1.1992 2.1289 1.7969 3.7656 1.7969zm-5.0781-15.484c1.0508-1.3945 2.2188-2.4219 3.5-3.0781 1.2812-0.66406 2.7539-1 4.4219-1 2.9453 0 5.3672 1.1719 7.2656 3.5156 1.8945 2.3438 2.8438 5.3594 2.8438 9.0469s-0.94922 6.7031-2.8438 9.0469c-1.8984 2.3438-4.3203 3.5156-7.2656 3.5156-1.668 0-3.1406-0.33594-4.4219-1s-2.4492-1.6914-3.5-3.0781v3.4531h-7.6562v-33.234h7.6562z" />
                          </symbol>
                          <symbol id="e" overflow="visible">
                            <path d="m0.53125-23.922h7.6562l6.4219 16.234 5.4688-16.234h7.6562l-10.062 26.188c-1.0117 2.6641-2.1953 4.5234-3.5469 5.5781-1.3438 1.0625-3.1211 1.5938-5.3281 1.5938h-4.4219v-5.0156h2.3906c1.3008 0 2.2422-0.21094 2.8281-0.625 0.59375-0.40625 1.0547-1.1484 1.3906-2.2188l0.20312-0.65625z" />
                          </symbol>
                          <symbol id="d" overflow="visible">
                            <path d="m4.0156-31.891h22.203v6.2188h-13.984v5.9375h13.141v6.2188h-13.141v13.516h-8.2188z" />
                          </symbol>
                          <symbol id="n" overflow="visible">
                            <path d="m3.6719-23.922h7.6562v23.922h-7.6562zm0-9.3125h7.6562v6.2344h-7.6562z" />
                          </symbol>
                          <symbol id="m" overflow="visible">
                            <path d="m27.734-14.562v14.562h-7.7031v-11.109c0-2.0938-0.046875-3.5312-0.14062-4.3125-0.085937-0.78125-0.24219-1.3594-0.46875-1.7344-0.30469-0.5-0.71094-0.88281-1.2188-1.1562-0.51172-0.28125-1.0938-0.42188-1.75-0.42188-1.5938 0-2.8516 0.61719-3.7656 1.8438-0.90625 1.2305-1.3594 2.9375-1.3594 5.125v11.766h-7.6562v-33.234h7.6562v12.812c1.1445-1.3945 2.3633-2.4219 3.6562-3.0781 1.3008-0.66406 2.7383-1 4.3125-1 2.7578 0 4.8516 0.85156 6.2812 2.5469 1.4375 1.6875 2.1562 4.1523 2.1562 7.3906z" />
                          </symbol>
                          <symbol id="l" overflow="visible">
                            <path d="m16.797-19.547c1.2891 0 2.2695-0.28125 2.9375-0.84375 0.67578-0.57031 1.0156-1.4141 1.0156-2.5312 0-1.0938-0.33984-1.9258-1.0156-2.5-0.66797-0.58203-1.6484-0.875-2.9375-0.875h-4.5625v6.75zm0.26562 13.953c1.6562 0 2.8984-0.34766 3.7344-1.0469 0.83203-0.69531 1.25-1.7539 1.25-3.1719 0-1.375-0.41797-2.4062-1.25-3.0938-0.82422-0.69531-2.0703-1.0469-3.7344-1.0469h-4.8281v8.3594zm7.6562-11.469c1.7578 0.51172 3.125 1.4609 4.0938 2.8438 0.96875 1.375 1.4531 3.0703 1.4531 5.0781 0 3.0742-1.043 5.3672-3.125 6.875-2.0742 1.5117-5.2305 2.2656-9.4688 2.2656h-13.656v-31.891h12.344c4.4258 0 7.6328 0.67188 9.625 2.0156 1.9883 1.3359 2.9844 3.4766 2.9844 6.4219 0 1.5547-0.36719 2.875-1.0938 3.9688-0.73047 1.0859-1.7812 1.8906-3.1562 2.4219z" />
                          </symbol>
                          <symbol id="k" overflow="visible">
                            <path d="m19.953-4.0625c-1.0547 1.3984-2.2148 2.4219-3.4844 3.0781-1.2734 0.65625-2.7422 0.98438-4.4062 0.98438-2.918 0-5.3281-1.1484-7.2344-3.4531-1.9062-2.3008-2.8594-5.2266-2.8594-8.7812 0-3.582 0.95312-6.5156 2.8594-8.7969s4.3164-3.4219 7.2344-3.4219c1.6641 0 3.1328 0.32812 4.4062 0.98438 1.2695 0.64844 2.4297 1.6797 3.4844 3.0938v-3.5469h7.6875v21.516c0 3.8438-1.2148 6.7734-3.6406 8.7969-2.4297 2.0312-5.9492 3.0469-10.562 3.0469-1.5 0-2.9492-0.11719-4.3438-0.34375-1.3984-0.21875-2.7969-0.57031-4.2031-1.0469v-5.9531c1.3438 0.76953 2.6562 1.3438 3.9375 1.7188s2.5664 0.5625 3.8594 0.5625c2.5078 0 4.3477-0.54688 5.5156-1.6406 1.1641-1.0938 1.75-2.8047 1.75-5.1406zm-5.0469-14.891c-1.5742 0-2.8047 0.58984-3.6875 1.7656-0.88672 1.168-1.3281 2.8203-1.3281 4.9531 0 2.1875 0.42578 3.8516 1.2812 4.9844 0.85156 1.1367 2.0977 1.7031 3.7344 1.7031 1.5938 0 2.832-0.58203 3.7188-1.75 0.88281-1.1758 1.3281-2.8203 1.3281-4.9375 0-2.1328-0.44531-3.7852-1.3281-4.9531-0.88672-1.1758-2.125-1.7656-3.7188-1.7656z" />
                          </symbol>
                          <symbol id="j" overflow="visible">
                            <path d="m3.4219-9.3125v-14.609h7.6875v2.3906c0 1.293-0.011719 2.918-0.03125 4.875-0.011719 1.9609-0.015625 3.2656-0.015625 3.9219 0 1.9297 0.046875 3.3125 0.14062 4.1562 0.10156 0.84375 0.28125 1.4609 0.53125 1.8438 0.3125 0.5 0.71875 0.88672 1.2188 1.1562 0.50781 0.27344 1.0938 0.40625 1.75 0.40625 1.5938 0 2.8438-0.60938 3.75-1.8281 0.91406-1.2266 1.375-2.9297 1.375-5.1094v-11.812h7.6406v23.922h-7.6406v-3.4531c-1.1562 1.3867-2.3828 2.4141-3.6719 3.0781-1.2812 0.66406-2.6992 1-4.25 1-2.7734 0-4.8828-0.84766-6.3281-2.5469-1.4375-1.6953-2.1562-4.1602-2.1562-7.3906z" />
                          </symbol>
                          <symbol id="i" overflow="visible">
                            <path d="m25.844-19.953c0.96875-1.4766 2.1172-2.6016 3.4531-3.375 1.332-0.78125 2.7969-1.1719 4.3906-1.1719 2.75 0 4.8438 0.85156 6.2812 2.5469 1.4375 1.6875 2.1562 4.1523 2.1562 7.3906v14.562h-7.6875v-12.469c0.007812-0.1875 0.019531-0.37891 0.03125-0.57812 0.007812-0.19531 0.015625-0.48438 0.015625-0.85938 0-1.6953-0.25-2.9258-0.75-3.6875-0.5-0.75781-1.3086-1.1406-2.4219-1.1406-1.4492 0-2.5703 0.60156-3.3594 1.7969-0.79297 1.1992-1.2031 2.9297-1.2344 5.1875v11.75h-7.6875v-12.469c0-2.6562-0.23047-4.3633-0.6875-5.125-0.44922-0.75781-1.2578-1.1406-2.4219-1.1406-1.4688 0-2.6055 0.60547-3.4062 1.8125-0.79297 1.1992-1.1875 2.918-1.1875 5.1562v11.766h-7.7031v-23.922h7.7031v3.5c0.9375-1.3516 2.0156-2.3672 3.2344-3.0469 1.2188-0.6875 2.5547-1.0312 4.0156-1.0312 1.6562 0 3.1133 0.40234 4.375 1.2031 1.2695 0.79297 2.2344 1.9062 2.8906 3.3438z" />
                          </symbol>
                        </defs>
                        <g>
                          <path d="m621.04 494.5-17.961-389.71c-0.20312-15.617-6.543-30.527-17.652-41.508-11.105-10.977-26.09-17.145-41.711-17.16h-277.98c-5.3789-12.516-14.309-23.18-25.688-30.668-11.379-7.4844-24.707-11.469-38.328-11.453h-0.35156l-35.227 0.375c-18.285 0.09375-35.801 7.3867-48.754 20.297-12.949 12.91-20.297 30.402-20.449 48.688l-18.008 413.09c0.007812 18.457 7.3477 36.156 20.406 49.199 13.062 13.047 30.77 20.367 49.227 20.352h0.33203l53.324-0.40234c2.6562-0.027344 5.3086-0.21094 7.9453-0.54297h351.58c15.738-0.015626 30.824-6.2734 41.953-17.398 11.129-11.129 17.387-26.215 17.406-41.953-0.027344-0.40234-0.050781-0.80469-0.070313-1.207zm-419.12 8.6016h-0.0625l-53.262 0.40234h-0.09375c-4.5 0.007812-8.8164-1.7812-11.996-4.9688-3.1133-3.0273-4.9219-7.1562-5.0312-11.496l17.965-413.09c0.007812-4.5234 1.8086-8.8594 5.0078-12.059 3.1992-3.1992 7.5391-5.0039 12.062-5.0117l35.234-0.40234h0.082031c4.5195 0.003906 8.8555 1.8008 12.055 4.9961 3.1992 3.1992 4.9961 7.5352 4.9961 12.059v412.52c0 4.5078-1.7852 8.8359-4.9648 12.035-3.1836 3.1992-7.4961 5.0117-12.008 5.043zm359.84-0.54297h-292.45c1.3555-5.3984 2.0547-10.941 2.0742-16.508v-387.43h272.34c3.7852 0 6.8555 3.0664 6.8633 6.8516v1.2148l17.953 389.38c-0.20312 3.6133-3.1641 6.4492-6.7812 6.4922z" />
                          <path d="m492.36 141.52h-159.44c-6.9648 0-13.641 2.7656-18.562 7.6875s-7.6875 11.598-7.6875 18.562v97.773-0.003906c0 6.9648 2.7656 13.641 7.6875 18.562s11.598 7.6875 18.562 7.6875h164.63c7.2109 0.011719 14.109-2.9453 19.074-8.1758s7.5625-12.273 7.1758-19.473l-5.1875-97.766c-0.35547-6.7148-3.2812-13.043-8.1641-17.668-4.8867-4.625-11.359-7.1992-18.086-7.1875zm-133.18 97.762v-45.262h108.28l2.3984 45.266z" />
                          <path d="m440.24 349.22c0 13.805-11.191 24.996-25 24.996-13.805 0-24.996-11.191-24.996-24.996 0-13.809 11.191-25 24.996-25 13.809 0 25 11.191 25 25" />
                          <path d="m521.78 349.22c0 13.805-11.195 24.996-25 24.996s-25-11.191-25-24.996c0-13.809 11.195-25 25-25s25 11.191 25 25" />
                          <path d="m358.7 349.22c0 13.805-11.195 24.996-25 24.996-13.809 0-25-11.191-25-24.996 0-13.809 11.191-25 25-25 13.805 0 25 11.191 25 25" />
                          <path d="m358.7 434.67c0 13.809-11.195 25-25 25-13.809 0-25-11.191-25-25 0-13.805 11.191-24.996 25-24.996 13.805 0 25 11.191 25 24.996" />
                          <path d="m440.24 434.67c0 13.809-11.191 25-25 25-13.805 0-24.996-11.191-24.996-25 0-13.805 11.191-24.996 24.996-24.996 13.809 0 25 11.191 25 24.996" />
                          <path d="m521.78 434.67c0 13.809-11.195 25-25 25s-25-11.191-25-25c0-13.805 11.195-24.996 25-24.996s25 11.191 25 24.996" />
                          <use x="70" y="691.25" />
                          <use x="102.109375" y="691.25" />
                          <use x="123.683594" y="691.25" />
                          <use x="153.355469" y="691.25" />
                          <use x="182.878906" y="691.25" />
                          <use x="203.792969" y="691.25" />
                          <use x="233.464844" y="691.25" />
                          <use x="280.011719" y="691.25" />
                          <use x="311.328125" y="691.25" />
                          <use x="355.078125" y="691.25" />
                          <use x="384.964844" y="691.25" />
                          <use x="414.488281" y="691.25" />
                          <use x="436.0625" y="691.25" />
                          <use x="451.0625" y="691.25" />
                          <use x="482.207031" y="691.25" />
                          <use x="526.960938" y="691.25" />
                          <use x="560.308594" y="691.25" />
                          <use x="589.980469" y="691.25" />
                          <use x="621.296875" y="691.25" />
                          <use x="652.441406" y="691.25" />
                        </g>
                      </svg>
                    </div>
                    {showetat_deskphone
                      ? deskphone(showetat_deskphone)
                      : etatPhonedevice(
                          collegue.collection.deskphone.etat,
                          collegue.collection.deskphone.encom
                        )}
                  </span>
                </div>
              ) : (
                <div></div>
              )}

              <CollegueProfile
                show={show}
                close={hideModal}
                collegue={collegue}
                //  t={}
              />
            </div>
          </div>

          <div className=" ml-2  inline-block text-left">
            <button
              data-tip
              data-for="infoTip"
              type="button"
              onClick={showModal}
              className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 dark:text-gray-200"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>

            <button
              data-tip
              disabled={String(collegue.poste) === poste}
              data-for="callTip"
              type="button"
              onClick={() =>
                dispatch({
                  type: "MAKE_CALL",
                  payload: {
                    number: collegue.poste,
                    type: "CALL",
                    image: collegue.lien_photo_poste_interne,
                    nom: collegue.nom,
                  },
                })
              }
              className={`
              ${
                String(collegue.poste) === poste
                  ? " cursor-not-allowed text-gray-200 pointer-events-none"
                  : "hover:text-green-600 focus:outline-none focus:ring-green-500 text-gray-500"
              }
              dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium  bg-gray-100  focus:ring-2 focus:ring-offset-2  m-1`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 dark:text-gray-200"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </button>

            {localStorage.getItem("isWEB") === "WEBRTC" && (
              <button
                data-tip
                data-for="callTip"
                type="button"
                onClick={() => appelVideo(collegue.poste)}
                className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 m-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-5 w-5 dark:text-gray-200"
                >
                  <path
                    strokeLinecap="round"
                    d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
                  />
                </svg>
              </button>
            )}
            <ReactTooltip
              id="callTip"
              place="bottom"
              effect="solid"
              data-background-color="yellow"
            >
              {t("Appeler")}
            </ReactTooltip>
            <ReactTooltip id="infoTip" place="bottom" effect="solid">
              {t("colleg.profil")}
            </ReactTooltip>
            {/* {collegue.canal_unified !== "" ? (
              <div className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 m-1">
                <Link
                  to={{
                    pathname: "/chat",
                    state: { fromDashboard: collegue.canal_unified },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 dark:text-gray-200 "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    />
                  </svg>
                </Link>
              </div>
            ) : (
              <div
                type="button"
                className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 m-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 dark:text-gray-700 text-gray-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                  />
                </svg>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Colleguebox);
